import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { getAuthData, isAuthenticated } from "../../../services/authService";
import axios from "axios";
import ENUMS from "../../../utils/ENUMS";
import { BASE_URL } from "../../../config.json";

const token = localStorage.getItem(ENUMS.AUTH);

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const [isExpired, setIsExpired] = useState(null);

  useEffect(() => {
    const authData = getAuthData();
    const role = (localStorage.getItem("userRole") || "").toLowerCase();

    if (role === "superadmin") {
      setIsExpired(false);
      return;
    }

    const fetchMembershipStatus = async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const res = await axios.get(`${BASE_URL}/club/home/`, config);
        const membershipStatus =
          res.data?.data?.club_membership?.subscription_mapping?.status?.value;

        setIsExpired(membershipStatus === "inactive");
      } catch (err) {
        console.error("Error checking membership status", err);
        setIsExpired(true); // default to expired on failure
      }
    };

    if (isAuthenticated()) {
      fetchMembershipStatus();
    } else {
      setIsExpired(false);
    }
  }, []);

  if (isExpired === null) return null;

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated() ? (
          <Redirect to="/club-login" />
        ) : isExpired ? (
          <Redirect to="/expired-account" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default ProtectedRoute;
